import React, { useEffect, useState } from "react";

import CustomIcons from "../../../components/icons/kIcons.component";
import { user_dash_list, user_deactivate } from "../user.api";
import DashApplicationDetails from "./components/application/dashApplication";
import CommonAppDetails from "./components/commonAppDetails/dashApplication";
import DashProfileDetails from "./components/profile/dashProfile";
import "./mydash.css";
import "./dashboard.css";
import Loader from "../../../components/loader/loader";
import jwtDecode from "jwt-decode";
import ManageDeactivate from "./components/manage/manageDeactivate";
import Snackbar from "../../../components/snackbar/snackbar";
import DeactivatedInfo from "./components/manage/deativatedInfo";
import { Button, Modal } from "react-bootstrap";

const quickLinks = [
  {
    name: "Directory of Kerala companies affiliated with KSPACE",
    link: "/directory-kerala",
    icon: "user",
  },
  { name: "Trade Enquiries", link: "/trade-enquiries", icon: "activity" },
  {
    name: "Directory of Aerospace institutions - India",
    link: "/directory-india",
    icon: "user",
  },

  {
    name: "Technology Transfer Proposals",
    link: "/tech-transfer-proposal-list",
    icon: "directory",
  },

  {
    name: "Directory of Aerospace institutions - International",
    link: "/directory-international",
    icon: "user",
  },

  {
    name: "Company Users",
    link: "/directory-company-users",
    icon: "user",
  },

  {
    name: "Spacepark Advisors",
    link: "/advisors",
    icon: "advisors",
  },
  {
    name: "Directory of Academic Institutions",
    link: "/institute-list",
    icon: "user",
  },
  {
    name: "Directory of Vendors",
    link: "/vendor-directory",
    icon: "directory",
  },

  {
    name: "Resource Personnel",
    link: "/resource-personal",
    icon: "user",
  },
  { name: "Job Seeker Profiles", link: "/candidates", icon: "resource" },
  { name: "Publications", link: "/publications", icon: "book" },

  // {
  //   name: "Expert Manpower",
  //   link: "/expert-manpower",
  //   icon: "user",
  // },


];

const applicationLinks = [
  {
    name: "Apply for New Company in KSPACE Premises",
    link: "/apply/new-company/kspace",
    icon: "activity",
  },
  {
    name: "Apply for New Company in Own Premises",
    link: "/apply/new-company/own",
    icon: "activity",
  },
  {
    name: "Affiliate Existing Aerospace Unit in Kerala",
    link: "/apply/register-kerala",
    icon: "user",
  },
  // {
  //   name: "Register Academic Institution",
  //   link: "/apply/institute-reg",
  //   icon: "user",
  // },
  // {
  //   name: "Register as Vendor",
  //   link: "/apply/vendors-reg",
  //   icon: "directory",
  // },
  // {
  //   name: "Register as Resource Personnel",
  //   link: "/apply/resource-personal-reg",
  //   icon: "user",
  // },
  // {
  //   name: "Register as Expert Manpower",
  //   link: "/apply/expert-manpower-reg",
  //   icon: "user",
  // },
  // {
  //   name: "Register as Job Seeker",
  //   link: "/apply/candidates-reg",
  //   icon: "resource",
  // },
];

export default function DashBoard(props) {
  const [activeMenu, setActiveMenu] = useState("application");
  const [data, setdata] = useState([]);
  const [mainData, setMainData] = useState({});
  const [isActive, setIsActive] = useState(false);
  const [appData, setAppData] = useState([]);
  const [url, setUrl] = useState("");
  const [open, setOpen] = useState(false);
  const [deactivatedInfo, setDeactivatedInfo] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [welcome, setWelcome] = useState(false);
  const ProfVist = localStorage.getItem("profileVisit");


  const handleDash = () => {
    setIsActive(true);
    user_dash_list().then((res) => {
      setMainData(res);
      setdata(res.data);
      setIsActive(false);
      setUrl(res.current_url);

      // Handle different data structures for different user types
      if (res?.data?.user_type === 21) {
        let feAdminUser = res.data;
        feAdminUser.status = 2;
        localStorage.setItem("app", JSON.stringify(feAdminUser));
        setAppData(res.data);
      } else if (res?.data?.is_company_user && res?.data?.company) {
        setAppData(res.data.company);
        localStorage.setItem("app", JSON.stringify(res.data.company));
      } else {
        setAppData(res.applications);
        localStorage.setItem("app", JSON.stringify(res.applications));
      }
    });
  };
  useEffect(() => {
    handleDash();
  }, []);
  const update = () => {
    props.history.push("/update-company");
  };
  const handleMenus = (menu) => {
    setActiveMenu(menu);
  };

  let userData = jwtDecode(props.state.payload);

  const getPath = (da) => {
    switch (da) {
      case 0:
        return "/update-company";

      case 4:
        return "/update-kspace";
      case 5:
        return "/update-kerala";
      case 6:
        return "/update-india";

      case 8:
        return "/update-academy";
      case 9:
        return "/update-resource";
      case 10:
        return "/update-manpower";
      case 20:
        return "/update-candidate";
      case 24:
        return "/vendor-registration";

      default:
        return "/";
    }
  };

  const handleQuickLinksNav = (link) => {
    props.history.push(link);
  };
  const updateProposal = (d) => {
    props.history.push(getPath(d));
  };
  const handleDeactivate = (id, fData) => {
    const data = {
      user_deactivate_message: fData.reason,
    };
    user_deactivate(id, data)
      .then((res) => {
        props.logout();
        props.history.push("/");
        // setOpen(false)
        setSnackMessage(res.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };
  const handleClose = () => {
    setWelcome(false);
  };
  useEffect(() => {
    if (!ProfVist || ProfVist < 1) {
      setWelcome(true);
    }
    localStorage.setItem("profileVisit", 1);
  }, [ProfVist]);
  useEffect(() => {
    if (userData?.user?.user_type == 20 && appData?.status === 9) {
      setDeactivatedInfo(true);
    }
  }, [userData?.user?.user_type, appData?.status]);

  return (
    <>
      <div className="dash">
        <div className="dash-banner "></div>
        <Loader open={isActive} />
        <div className="container ">

          <div className="dashBox-container">

            <div className="dashboard-box">

              <div className="dash-items">
                {/* ------------------my dashboard------------------------------------ */}

                <div className="mydash">
                  <div className="fill-color">
                    <div className="dash-content-container">
                      <div className="dash-content-details-container">

                        <div className="">
                          {activeMenu === "application" && (
                            <DashApplicationDetails
                              data={
                                (data?.user_type === 0 || data?.user_type === 4) ||
                                  (userData?.user?.user_type === 0 || userData?.user?.user_type === 4 || userData?.user?.user_type === 5 || userData?.user?.user_type === 6)
                                  ? data?.is_company_user
                                    ? data // For company users, pass the main user data
                                    : data?.applicants
                                  : data
                              }
                              userType={data?.user_type || userData?.user?.user_type}
                              appData={appData}
                              url={url}
                              updateProposal={updateProposal}
                              dashMenu={props?.setDashMenuOpen}
                              handleMenus={handleMenus}
                              handleOpen={setOpen}
                              status={data?.application_status_message}
                              {...props}
                            />
                          )}

                          {activeMenu === "profile" && (
                            <DashProfileDetails
                              data={appData}
                              userData={appData}
                              userType={data?.user_type || userData?.user?.user_type}
                              url={url}
                              handleMenus={handleMenus}
                              status={data?.application_status_message}
                              {...props}
                              userDetails={userData}
                              companyData={data?.is_company_user ? data : null}
                            />
                          )}
                          {(data?.user_type === 0 || data?.user_type === 4) ||
                            (userData?.user?.user_type === 0 || userData?.user?.user_type === 4)}
                          {
                            <>
                              <div className="d-flex justify-content-start px-3" style={{ backgroundColor: '#e3eefa' }}>
                                <button
                                  className="btn btn-primary"
                                  onClick={() => props.history.push("/kspace-messages")}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    borderRadius: '8px',
                                    padding: '10px 20px',
                                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  <i className="fa fa-envelope"></i>
                                  KSPACE MESSAGES
                                </button>
                              </div>

                              <div className="mydash px-3 d-flex justify-content-start">
                                <div className="ql-main ">
                                  <div className="dashuserStatus-ql  justify-content-start">
                                    Quick Links
                                  </div>
                                  <div className="px-2 mt-2">
                                    <div className="row">
                                      {quickLinks?.map((item, i) => (
                                        <div className=" col-12 col-md-6" key={i}>
                                          <div
                                            className=" ql-item"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              handleQuickLinksNav(item?.link);
                                            }}
                                          >
                                            <div className="col-10">
                                              {item?.name}
                                            </div>
                                            <div className=" sub-ql col-2">
                                              <CustomIcons
                                                iconName={item.icon ?? "view"}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {!data?.is_company_user && ([0, 4, 5].includes(userData?.user?.user_type) || [0, 4, 5].includes(userData?.user_type) || [0, 4, 5].includes(data?.user_type)) && (
                                <div className="mydash px-3 d-flex justify-content-start">
                                  <div className="ql-main ">
                                    <div className="dashuserStatus-ql  justify-content-start">
                                      Submit New Applications
                                    </div>
                                    <div className="px-2 mt-2">
                                      <div className="row">
                                        {applicationLinks?.map((item, i) => (
                                          <div className=" col-12 col-md-6" key={i}>
                                            <div
                                              className=" ql-item"
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                handleQuickLinksNav(item?.link);
                                              }}
                                            >
                                              <div className="col-10">
                                                {item?.name}
                                              </div>
                                              <div className=" sub-ql col-2">
                                                <CustomIcons
                                                  iconName={item.icon ?? "view"}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          }
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ManageDeactivate
        handleOpen={setOpen}
        open={open}
        appData={appData}
        handleDeactivate={handleDeactivate}
      />
      <DeactivatedInfo
        handleOpen={setDeactivatedInfo}
        open={deactivatedInfo}
        appData={appData}
      //  handleDeactivate={handleDeactivate}
      />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      {welcome && (
        <Modal
          show={welcome}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header className="payment-modal">
            <Modal.Title id="contained-modal-title-vcenter">
              Welcome to KSPACE
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "2rem" }}>
            <div className="text-center">
              <p style={{
                fontSize: "1.25rem",
                fontWeight: "600",
                color: "#2c3e50",
                lineHeight: "1.6",
                marginBottom: "2rem"
              }}>
                We're glad to have{" "}
                <span style={{
                  color: "#3498db",
                  fontWeight: "700",
                  fontSize: "1.35rem"
                }}>
                  {userData?.user?.company_name
                    ? userData?.user?.company_name
                    : userData?.user?.institution_name
                      ? userData?.user?.institution_name
                      : userData?.user?.name
                        ? userData?.user?.name
                        : userData?.user?.first_name
                          ? userData?.user?.first_name
                          : ""}
                </span>{" "}
                registered with us.
              </p>

              <div style={{
                backgroundColor: "#f8f9fa",
                padding: "1.5rem",
                borderRadius: "8px",
                marginTop: "1.5rem"
              }}>
                <div style={{ marginBottom: "1rem" }}>
                  <label style={{
                    fontSize: "0.860rem",
                    color: "#6c757d",
                    fontWeight: "500",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    display: "block",
                    marginBottom: "0.25rem"
                  }}>
                    Registered Email ID
                  </label>
                  <span style={{
                    fontSize: "0.860rem",
                    color: "#2c3e50",
                    fontWeight: "600"
                  }}>
                    {userData?.user?.email}
                  </span>
                </div>
                <hr style={{
                  margin: "1rem 0"
                }}></hr>
                <div>
                  <label style={{
                    fontSize: "0.860rem",
                    color: "#6c757d",
                    fontWeight: "500",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    display: "block",
                    marginBottom: "0.25rem"
                  }}>
                    Registered Mobile Number
                  </label>
                  <span style={{
                    fontSize: "0.860rem",
                    color: "#2c3e50",
                    fontWeight: "600"
                  }}>
                    {userData?.user?.mobile_number}
                  </span>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={(e) => handleClose()}>OK</Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}
